import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import Home from './pages/Home';
import About from './pages/About';
// import BookingList from './pages/BookingList';
import { useJQueryInit } from './hooks/useJQueryInit';
import MyContact2 from './pages/MyContact2';
import Events from './pages/Events';
import UpcomingEvents from './pages/UpcomingEvents';
import YearlyActivities from './pages/YearlyActivities'
import SocialActivities from './pages/SocialActivities'
import Services from './pages/Services'
import Publications from './pages/Publications'
import MonthlyMagazines from './pages/MonthlyMagazines'
import BookingSeva from './pages/BookingSeva';
import OnlineSevaBooking from './pages/OnlineSevaBooking';
import GuruSevaBooking from './pages/GuruSevaBooking';
import BookingDonation from './pages/BookingDonation'
import BookingRoom from './pages/BookingRoom'
import BillingPage from './pages/BillingPage'
import HowToReach from './pages/HowToReach'
import Gallery from './pages/Gallery'
import BookingSection from './pages/Test';
import BookingForm from './pages/BookingForm';
import RoomBooking from './pages/RoomBooking';
import Login from './pages/Login';
import Profile from './pages/Profile';
import OrderDetail from './pages/OrderDetail';
import AdminPayments from './pages/AdminPayments';
import CloneBooking from './pages/CloneBooking';
import AdminRoomBooking from './pages/AdminRoomBooking';
import RoomBlocking from './pages/RoomBlocking';
import BookingList from './pages/BookingList';
import PaymentReport from './pages/PaymentReport';

import SevaBookingSummary from './pages/SevaBookingSummary';
import PaymentHistory from './pages/PaymentHistory';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import PaymentStatus from './pages/PaymentStatus';

import BookingTimeSelection from './pages/BookingTimeSelection';
import ApplicationSettings from './pages/ApplicationSettings';
//import MyOrders from './pages/MyOrders';
//import OrderDetails from './pages/OrderDetails';

const App = () => {
  useJQueryInit();

  return (
    <Router basename="/web">
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <BookingSection/> */}
          {/* <Route path="/about" element={<About />} /> */}
          {/* <Route path="/about" element={<BookingSection />} /> */}
          {/* <Route path="/about" element={<BookingList />} /> */}
          {/* <Route path="/about" element={<BookingForm />} /> */}

          <Route path="/about" element={<About />} />
          {/* <Route path="/about" element={<RoomBooking />} /> */}

          {/* <Route path='/test' element={<MyContact2/>}/> */}
          <Route path='/events' element={<Events />} />
          <Route path='/upcoming-events' element={<UpcomingEvents />} />
          <Route path='/yearly-activities' element={<YearlyActivities />} />
          <Route path='/social-activities' element={<SocialActivities />} />
          <Route path='/services' element={<Services />} />
          <Route path='/publications' element={<MonthlyMagazines />} />
          <Route path='/booking-seva' element={<BookingSeva />} />
          <Route path='/contact' element={<MyContact2 />} />
          <Route path='/OnlineSevaBooking' element={<OnlineSevaBooking />} />
          <Route path='/seva-summary' element={<SevaBookingSummary />} />
          <Route path='/payment-history' element={<PaymentHistory />} />
          <Route path='/gurusevabooking' element={<GuruSevaBooking />} />
          <Route path='/bookingdonation' element={<BookingDonation />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-conditions' element={<TermsConditions />} />
          <Route path='/refund-policy' element={<RefundPolicy />} />
          <Route path='/payment/status' element={<PaymentStatus />} />

          {/* <Route path='/bookingroom' element={<BookingRoom />} /> */}
          <Route path='/bookingroom' element={<CloneBooking />} />
          <Route path='/booking-process' element={<BookingRoom />} />
          <Route path='/room-availability' element={<CloneBooking />} />
          <Route path='/booking-time' element={<BookingTimeSelection />} />
          {/* <Route path="/about" element={<BookingRoom />} /> */}



          <Route path="/billing" element={<BillingPage />} />
          <Route path="/order-details/:id" element={<OrderDetail />} />
          <Route path="/admin/order-details/:id" element={<OrderDetail />} />
          <Route path='/howtoreach' element={<HowToReach />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path="/login" element={<Login />} />
          <Route path="/profile" element={<Profile />} />
          {/*<Route path="/me/orders" element={<MyOrders />} />
          <Route path="/me/order/:id" element={<OrderDetails />} />*/}
          <Route path="/admin/payments" element={<AdminPayments />} />

          {/* Admin Routes */}
          <Route path="/admin/cro-booking" element={<AdminRoomBooking />} />
          <Route path="/admin/room-blocking" element={<RoomBlocking />} />
          <Route path="/admin/bookings" element={<BookingList />} />
          <Route path="/admin/reports" element={<PaymentReport />} />
          <Route path="/admin/settings" element={<ApplicationSettings />} />

          {/* BookingDonation */}
        </Routes>
        <Footer />
        <BackToTop />
      </div>
    </Router>
  );
};

export default App;
